import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Langs, { Localize } from "../../app/lang/langs";
import { Col, Row } from "react-bootstrap";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { getCollabsNames } from "../../components/vcomp/vcompSlice";
import { setTeamManagers, ctAddTeamManager } from "../../components/teams/teamsSlice";
import { getManagersProfiles } from "../../components/permissions/permissionsSlice";
import { showErrorToast } from "../../app/utils/helpers";
import { Dropdown } from "primereact/dropdown";

export default function AddTeamManagersModal(props) {

    const dispatch = useDispatch();
    const collabsNames = useSelector((state) => state.vcomp.collabsNames);
    const managersProfiles = useSelector((state) => state.permissions.assignableProfiles);
    const [filteredCollabs, setFilteredCollabs] = useState([]);
    const [selectedManager, setSelectedManager] = useState(null);
    const [managerType, setManagerType] = useState(null);

    useEffect(() => {
        dispatch(getCollabsNames())
    }, [dispatch])

    useEffect(() => {
        if (props.visible && props.idTeam) {
            dispatch(getManagersProfiles({ idTeam: props.idTeam }))
        }
    }, [props.visible, props.idTeam])

    useEffect(() => {
        setFilteredCollabs(collabsNames.filter(collab =>
            !props.prevManagers.some(manager => manager.id_collab === collab.id)
        ).map(({ id, nom, prenom, email }) => ({
            id,
            nom,
            prenom,
            email,
            fullName: `${prenom} ${nom} `
        })));
    }, [collabsNames, props.prevManagers]);

    const handleClose = () => {
        props.setVisible(false);
        setSelectedManager(null);
        setManagerType(null);
    };

    const handleAddManager = () => {
        if (selectedManager && props.idTeam && managerType) {
            const managerData = {
                id_team: props.idTeam,
                id_collab: selectedManager.id,
                id_manager_profile: managerType.id,
            };

            dispatch(ctAddTeamManager(managerData))
                .then((actionResponse) => {
                    if (ctAddTeamManager.fulfilled.match(actionResponse)) {
                        const newManager = {
                            id: actionResponse.payload.id,
                            id_team: props.idTeam,
                            id_collab: selectedManager.id,
                            id_manager_profile: managerType.id,
                            type: managerType.name,
                            nom: selectedManager.nom,
                            prenom: selectedManager.prenom,
                            email: selectedManager.email,
                        };

                        dispatch(setTeamManagers([...props.prevManagers, newManager]));
                        handleClose();
                    }
                })
                .catch((error) => {
                    console.error('Erreur lors de l\'ajout du manager :', error);
                    showErrorToast('Erreur lors de l\'ajout du manager.');
                });
        }
    };

    const header = () => (
        <div>
            <Langs str='ADD_MANAGER' />
        </div>
    );

    const body = () => (
        <div className="p-2">
            <Row className="mt-2 p-2 pb-3">
                <Col lg={3} className="my-3 fw-bold">
                    <Langs str='SELECT_COLLAB' />
                </Col>
                <Col lg={9} className="d-flex justify-content-end">
                    <Dropdown
                        value={selectedManager}
                        onChange={(e) => setSelectedManager(e.value)}
                        options={filteredCollabs}
                        optionLabel="fullName"
                        placeholder={Localize('SELECT_COLLAB_PLACEHOLDER')}
                        className="w-100"
                        filter
                        filterBy="fullName"
                        showClear
                    />
                </Col>
            </Row>
            <Row className="mt-2 p-2 pb-3">
                <Col lg={3} className="my-3 fw-bold">
                    <Langs str="MANAGER_TYPE" />
                </Col>
                <Col lg={9} className="d-flex align-items-center">
                    <Dropdown
                        value={managerType}
                        onChange={(e) => setManagerType(e.value)}
                        options={managersProfiles}
                        optionLabel="name"
                        placeholder={Localize('SELECT_PROFILE_PLACEHOLDER')}
                        className="w-100"
                        style={{height: "54px"}}
                    />
                </Col>
            </Row>
        </div>
    );

    const footer = () => (
        <Row className="d-flex justify-content-center border-top pt-3">
            <Col lg={3} xs={3}>
                <DynamicButton
                    onClick={handleAddManager}
                    title={<Langs str="ADD" />}
                    active={true}
                    color="green"
                />
            </Col>
        </Row>
    );

    return (
        <Dialog
            header={header}
            footer={footer}
            visible={props.visible}
            style={{ width: '50vw' }}
            draggable={false}
            onHide={handleClose}
        >
            {body()}
        </Dialog>
    );
}
